module.exports = __webpack_public_path__ + "static/media/banner_CBD.c56b23b7.png";